import './App.css';
import React from "react";
import {Navbar} from "./components/common";
import {
    BrowserRouter as Router,
    Routes,
    Route,
} from "react-router-dom";
import {Home, About} from "./pages";
import ScrollToTop from './assets/js/scrollToTop';

function App() {
  return (
    <Router>
      <ScrollToTop/>
      <Navbar/>
      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/about" element={<About/>}/>

      </Routes>
    </Router>
  );
}

export default App;
